import { useEffect, useState } from 'react';
import { flushOutbox, outboxCount } from '../lib/outbox.js';

export function useConnectivity() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    const refresh = () => void outboxCount().then(setPending);
    const connected = () => {
      setOnline(true);
      setSyncing(true);
      void flushOutbox().finally(() => {
        setSyncing(false);
        refresh();
      });
    };
    const disconnected = () => setOnline(false);
    window.addEventListener('online', connected);
    window.addEventListener('offline', disconnected);
    window.addEventListener('rahul365:outbox-change', refresh);
    refresh();
    if (navigator.onLine) connected();
    return () => {
      window.removeEventListener('online', connected);
      window.removeEventListener('offline', disconnected);
      window.removeEventListener('rahul365:outbox-change', refresh);
    };
  }, []);

  return { online, pending, syncing };
}
